<div [ngClass]="{ 'half-screen': selectedDepartment }" class="main-container">
    <app-list-header
        [title]="title"
        [closable]="!!choiceEvent.topic"
        [searchPlaceholder]="'departments.search' | translate"
        [searchTerm]="searchTerm | async"
        (searchTermChange)="searchTerm.next($event);searchDepartments()"
        (clearSearch)="clearDepartmentsFilter()"
        (addNewItem)="createNewDepartment()"
    >
    </app-list-header>

    <div class="table-container">
        <table class="table">
            <thead>
                <tr>
                    <th>{{ 'departmentDetails.nameLabel' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let department of filteredDepartment | async"
                    (click)="select(department)"
                    [class.selected]="department === selectedDepartment"
                >
                    <td class="name-cell">{{ department.name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
